module.exports = __webpack_public_path__ + "static/media/flue.fafc8b82.m4a";